import { render } from "./App.vue?vue&type=template&id=937561f8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=937561f8&lang=scss"

import exportComponent from "/tmp/tesla_data/tmp/apply_3091/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__